/** Клиентский доступ к платному модулю «Мессенджеры» (подписка). */

export const MESSENGERS_MODULE_PRICE_RUB = 490;

const MESSENGERS_ALLOWED_SUBDOMAINS = new Set(["baysport"]);

export function isMessengersModuleAllowed(tenantOrSubdomain) {
  const sub =
    typeof tenantOrSubdomain === "string"
      ? tenantOrSubdomain
      : tenantOrSubdomain?.subdomain;
  return MESSENGERS_ALLOWED_SUBDOMAINS.has(
    String(sub || "").trim().toLowerCase(),
  );
}

export function formatPriceRub(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "—";
  return `${n.toLocaleString("ru-RU")} ₽`;
}

export function isMessengersModuleActive(moduleOrTenant, plan) {
  if (plan?.messengers) return true;
  if (!moduleOrTenant) return false;
  if (moduleOrTenant.active != null) return Boolean(moduleOrTenant.active);
  if (moduleOrTenant.purchased != null && moduleOrTenant.paid_until == null) {
    return Boolean(moduleOrTenant.purchased);
  }
  const until =
    moduleOrTenant.paid_until || moduleOrTenant.messengers_paid_until;
  if (!until) return false;
  return String(until).slice(0, 10) >= new Date().toISOString().slice(0, 10);
}

/** @deprecated use isMessengersModuleActive */
export function isMessengersModulePurchased(moduleOrTenant, plan) {
  return isMessengersModuleActive(moduleOrTenant, plan);
}
